import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from '../modals/DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import CPFMaskInput from '../masks/CPFMaskInput';
import { unformatCPF } from '../../utils/cpfUtils';

function ResponsabilidadeModal({
  isOpen,
  responsabilidade,
  cnpjAtual,
  onClose,
  onSuccess,
}) {
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  const [formData, setFormData] = useState({
    cnpj: cnpjAtual,
    id: 0,
    nome: '',
    cpf: '',
    matricula: '',
    cargo: '',
    dfd: 'N',
    aprovaDfd: 'N',
    pca: 'N',
  });

  useEffect(() => {
    if (responsabilidade) {
      setFormData(responsabilidade);
    } else if (isOpen) {
      getNextId();
    }
  }, [isOpen, responsabilidade]);

  const getNextId = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL.RESPONSABILIDADE}/next-id?cnpj=${cnpjAtual}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setFormData((prev) => ({
        cnpj: cnpjAtual,
        id: response.data,
        nome: '',
        cpf: '',
        matricula: '',
        cargo: '',
        dfd: 'N',
        aprovaDfd: 'N',
        pca: 'N',
      }));
    } catch (error) {
      console.error('Erro ao obter próximo ID:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 'S' : 'N') : value,
    });
  };

  const handleSave = async () => {
    if (!formData.nome.trim()) {
      showDefaultModal('warning', 'Nome é obrigatório.');
      return;
    }

    try {
      const payload = {
        ...formData,
        cpf: formData.cpf ? unformatCPF(formData.cpf) : '',
      };

      if (responsabilidade) {
        await axios.put(`${API_BASE_URL.RESPONSABILIDADE}/update`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_BASE_URL.RESPONSABILIDADE}/save`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      onClose();
      onSuccess();
    } catch (error) {
      console.error('Erro ao salvar:', error.response?.data || error.message);
      const errorMsg = error.response?.data?.message || 'Erro ao salvar responsabilidade.';
      showDefaultModal('error', errorMsg);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal d-block"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header text-white py-1" style={{ background: 'linear-gradient(90deg, #0b3383, #0e48ad)' }}>
              <h6 className="modal-title text-center m-0">
                {responsabilidade
                  ? 'Editar Responsabilidade'
                  : 'Nova Responsabilidade'}
              </h6>
              <button
                className="btn btn-link text-white p-0 mb-0"
                onClick={onClose}
                title="Fechar"
                style={{ fontSize: '0.9rem', textDecoration: 'none' }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="form-label">Nome *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nome"
                      value={formData.nome}
                      onChange={handleInputChange}
                      placeholder="Nome completo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">CPF</label>
                    <CPFMaskInput
                      name="cpf"
                      value={formData.cpf}
                      onChange={handleInputChange}
                      placeholder="000.000.000-00"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Matrícula</label>
                    <input
                      type="text"
                      className="form-control"
                      name="matricula"
                      value={formData.matricula}
                      onChange={handleInputChange}
                      placeholder="Matrícula"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="form-label">Cargo</label>
                    <input
                      type="text"
                      className="form-control"
                      name="cargo"
                      value={formData.cargo}
                      onChange={handleInputChange}
                      placeholder="Cargo/Função"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="dfd"
                        id="dfdCheck"
                        checked={formData.dfd === 'S'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="dfdCheck">
                        Responsável DFD
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="aprovaDfd"
                        id="aprovaDfdCheck"
                        checked={formData.aprovaDfd === 'S'}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="aprovaDfdCheck"
                      >
                        Aprova DFD
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="pca"
                        id="pcaCheck"
                        checked={formData.pca === 'S'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="pcaCheck">
                        Responsável PCA
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>

      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default ResponsabilidadeModal;
